import {OnInit, AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild, ViewContainerRef, ComponentRef} from "@angular/core";
import {AppService} from "@api";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {DxDataGridComponent} from "devextreme-angular";
import {AlumnoComponent} from '@contenido/AppContent/evaluacionpendiente/alumno/alumno.component';
import { EvaluacionAlumno } from "@modelo/global/EvaluacionAlumno.model";

@Component({
    selector: 'asignacionevaluacionalumnos_materias',
    templateUrl: './asignacionevaluacionalumno_materia.component.html',
})

export class AsignacionEvaluacionAlmunosMateriasComponent implements OnInit, AfterViewInit {
    consulta!:boolean;
    @Input() id!: number;
    @Input() idnivel!: number;
    @Input() idtipoevaluacion!: number;
    @Input() periodoevaluacionportipoevaluacionid!: number;
    @Input() identificador!: number;
    @Output() output = new EventEmitter();
    @Output() prevista = new EventEmitter();
    @Output() salir = new EventEmitter();

    valoraccion: any;
    cambio!: boolean;
    filtros: any;
    DataGrados: any[];
    asignacion: any[] = [];
    visualizar: boolean = false;
    valordato: number = 0;
    itemTemplate:any;

    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;
    @ViewChild("containerEvaluacion", {read: ViewContainerRef}) containerEvaluacion!: ViewContainerRef;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
        this.DataGrados = [];
        this.itemTemplate = '<div style="background-color: ${data.color}"></div>'
    }

    ngOnInit() {
        if (this.identificador == 2) {
            this.visualizar = true;
        }
    }

    ngAfterViewInit() {
        this.SetNivelYGrado();
        this.SetAsignacion();
    }

    preevisualizar(e:any, entidad:any){
        if(e.value){
            let val = new EvaluacionAlumno();
            val.gradoid = entidad.gradoid;
            val.nivelid = entidad.nivelid;
            val.materiaid = e.value;
            val.tipoplantillaid = 2;
            val.tipovisualizacioncompetenciacriterioid = entidad.tipovisualizacioncompetenciacriterioid;
            val.tipovisualizacionpreguntaid = entidad.tipovisualizacionpreguntaid;
            val.tipovisualizacionrespuestaid = entidad.tipovisualizacionrespuestaid;
            val.evaluadorid = entidad.evaluadorid
            this.prevista.next(val);
        }

    }

    vermaterias(e:any, entidad:any){
        entidad.tipoasignacionid = e.value;
        if(e.value == 1 && e.previousValue == 2){
            entidad.listamateriainiciar = entidad.listamateriatodosatodos;
        }
        if(e.value == 2 && e.previousValue == 1){
            entidad.listamateriainiciar = entidad.listamateriapormateria;
        }
    }

    SetNivelYGrado() {
        this.appService.Get("planeacion/asignacionevaluacion/nivel/" + this.periodoevaluacionportipoevaluacionid).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.DataGrados = res.data;
            }
        });
    }

    SetAsignacion() {
        this.appService.Get("planeacion/asignacionevaluacion/asignacion").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.asignacion = res.data;
            }
        })
    }

    Formulario(accionid: number, entidad: any) {
        let accion: string = ""
        if (entidad.tipoasignacionid == 2) {
            switch (accionid) {
                case 1:
                    accion = "Ver";
                    break;
                case 2:
                    accion = "Editar";
                    break;
            }
            this.CambiarFormulario({accion: accion, entidad: entidad, periodoevaluacionportipoevaluacionid: this.periodoevaluacionportipoevaluacionid, accionid: accionid});
        }
    }

    CambiarFormulario(data: {accion: string, entidad: any, periodoevaluacionportipoevaluacionid: number, accionid: number}) {
        this.cambio = true;
        this.valoraccion = data;
        this.output.next();
    }

    Guardar() {
        this.appService.Put("planeacion/asignacionevaluacion/actualizar/tipoasignacion", this.DataGrados).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SetNivelYGrado();
            }
        })
    }

    onRowPrepared(e:any){
        // if(e.parentType == "dataRow" && e.caption == "preevisualizar" && e.row.rowType == "data"){
        //     let data = e.row.key;
        //     if(e.row.key.listamateria){
        //         e.lookup.items = data.listamateria;
        //         e.lookup.dataSource = data.listamateria;
        //     }
        // }
    }
}
